<section class="users-edit" *ngIf="currentUrl == 'users-edit/:id'">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- Nav-tabs -->
            <ul
              ngbNav
              #nav="ngbNav"
              [activeId]="1"
              class="nav-tabs justify-content-left"
            >
              <li [ngbNavItem]="1">
                <a ngbNavLink class="nav-link d-flex align-items-center">
                  <i class="ft-user mr-1"></i>
                  <span class="d-none d-sm-block">Account</span>
                </a>
                <ng-template ngbNavContent>
                  <!-- Account content starts -->
                  <div class="mt-2" id="account">
                    <!-- Media object starts -->
                    <div class="media">
                      <!-- <img class="avatar" *ngIf="userData.image;else no_profile_image" [src]="imageUrl+userData.image"
                      alt="avatar" height="35" width="35" />
                      <ng-template #no_profile_image><img class="avatar" [src]="'assets/img/no_logo_found.jpeg'"
                        alt="avatar" height="35" width="35" /></ng-template> -->
                      <!-- <img *ngIf="!userData?.image" class="avatar" [src]="'assets/img/no_logo_found.jpeg'"
                        alt="avatar" height="64" width="64"> -->

                      <img
                        *ngIf="imgUrl"
                        [src]="imgUrl"
                        alt="user edit avatar"
                        class="users-avatar-shadow rounded mr-3 object-fit-cover"
                        height="64"
                        width="64"
                      />
                      <img
                        *ngIf="!imgUrl && userData?.image"
                        [src]="userData?.image"
                        alt="user edit avatar"
                        class="users-avatar-shadow rounded mr-3 object-fit-cover"
                        height="64"
                        width="64"
                      />
                      <div
                        *ngIf="!imgUrl && !userData?.image"
                        [class.initial-alpha]="!userData?.image"
                        class="users-avatar-shadow mr-1 ml-0"
                      >
                        <div class="users-avatar-shadow avatar rounded-circle">
                          {{ userData?.name | titlecase | shortName }}
                        </div>
                      </div>
                      <!-- <div *ngIf="userData?.image">
                          <img class="users-avatar-shadow rounded mr-1" [src]="imgUrl"
                            height="64" width="64" alt="datatable-avatar">
                          <img class="users-avatar-shadow rounded mr-1" [src]="imageUrl + userData?.image"
                            height="64" width="64" alt="datatable-avatar">
                        </div>
                        
                          <div *ngIf="!userData?.image" [class.initial-alpha]="!userData?.image" class="users-avatar-shadow rounded mr-1 ml-0" >
                            <div class="avatar-content">{{ userData?.name | shortName }}</div>
                          </div> -->

                      <div class="media-body">
                        <h4>{{ userData?.name | titlecase }}</h4>
                        <div
                          class="d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2"
                        >
                          <label
                            class="btn btn-sm btn-primary mb-1 mb-sm-0 text-transform-unset"
                            >Change
                            <input
                              type="file"
                              #fileInput
                              class="form-control"
                              (change)="onSelectFile($event)"
                              hidden
                            />
                          </label>
                          <!-- <button
                            class="btn btn-sm bg-light-secondary ml-sm-2"
                            (click)="resetImage()"
                          >
                            Reset
                          </button> -->
                        </div>
                      </div>
                    </div>
                    <!-- Media object ends -->

                    <!-- Account form starts -->
                    <form novalidate>
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <fieldset class="form-group">
                            <label for="name">Role</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="userData.roles"
                              [ngModelOptions]="{ standalone: true }"
                              id="name"
                              placeholder="Enter role"
                              readonly
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="name">Name</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="userData.name"
                              [ngModelOptions]="{ standalone: true }"
                              id="name"
                              placeholder="Enter name"
                              readonly
                            />
                          </fieldset>

                          <fieldset class="form-group">
                            <label for="Email">Email</label>
                            <input
                              type="email"
                              class="form-control"
                              [(ngModel)]="userData.email"
                              [ngModelOptions]="{ standalone: true }"
                              id="Email"
                              placeholder="Enter email"
                              #email
                            />
                            <!-- <fieldset class="form-group">
                            <label for="sex">Sex</label>
                            <input
                              type="text"
                              [(ngModel)]="userData.gender"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="sex" readonly />
                          </fieldset> -->
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="college">Phone</label>
                            <input
                              type="text"
                              placeholder="e.g. 1234-567-890"
                              mask="0000-000-000"
                              minlength="10"
                              [(ngModel)]="userData.phone"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="phone"
                              placeholder="Enter phone"
                              #phone
                            />
                          </fieldset>
                          <!-- <fieldset class="form-group">
                            <label for="location">Location</label>
                            <input
                              
                              [(ngModel)]="userData.location.address"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              name="comment2"
                              (keydown.enter)="$event.preventDefault()"
                              placeholder="Enter Location" autocorrect="off" 
                              autocapitalize="off" spellcheck="off" type="text" #search
                            
                            >
                          </fieldset> -->
                          <fieldset class="form-group">
                            <label for="dob">Date Of Birth</label>
                            <input
                              type="date"
                              [(ngModel)]="userData.dob"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="dob"
                            />
                          </fieldset>
                          <fieldset>
                            <label for="">Gender</label>
                            <select
                              class="form-control"
                              aria-placeholder="Sex"
                              (change)="change($event)"
                              [(ngModel)]="userData.sex"
                              [ngModelOptions]="{ standalone: true }"
                            >
                              <option value="">Select Gender</option>
                              <option value="male">male</option>
                              <option value="female">female</option>
                            </select>
                          </fieldset>
                          <!------------------------ Student Form Fields ------------------------------------>
                          <!-- <fieldset class="form-group">
                          <label for="bio">Bio</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.bio"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="bio" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="badges">Badges</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.badges"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="badges" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="goal">Goal</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.goal"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="goal" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="mode">Mode</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.mode"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="mode" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="hunting_by">Hunting By</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.hunting_by"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="hunting_by" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="farming_by">Farming By</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.farming_by"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="farming_by" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="team">Team</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.team"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="team" readonly />
                        </fieldset> -->
                          <!-- ---------------- End -------------------------------------------- -->
                        </div>
                        <div class="col-12 col-md-6">
                          <!-- ----------------User Form Fields -------------------------------------------- -->
                          <!-- <fieldset class="form-group">
                            <label for="address">address</label>
                            <input
                              type="text"
                              [(ngModel)]="userData.address"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="address"
                              placeholder="Enter address"
                           #address />
                          </fieldset> -->
                          <!-- <fieldset class="form-group">
                            <label for="location">location</label>
                            <input
                              type="text"
                              [(ngModel)]="userData.location.coordinates"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="location"
                              placeholder="Enter location"
                           #location />
                          </fieldset> -->

                          <fieldset class="form-group">
                            <label for="linked_in">Linked In</label>
                            <input
                              type="text"
                              [(ngModel)]="userData.linkedIn"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="linked_in"
                              placeholder="Enter Linked In"
                              #linked_in
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="notes">notes</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="5"
                              [(ngModel)]="userData.notes"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              name="comment2"
                              placeholder="Enter notes"
                              #notes
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="admin_notes">Admin Notes</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="5"
                              [(ngModel)]="userData.admin_notes"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              name="comment2"
                              placeholder="Enter admin notes"
                              #admin_notes
                            ></textarea>
                          </fieldset>
                          <!-- ---------------------- End ----------------------------------------------------------------- -->
                          <!-- ---------------------- Student Form Fields  ----------------------------------------------------------------- -->

                          <!-- <fieldset class="form-group">
                            <label for="college_id">College</label>
                            <input
                              type="text"
                              [(ngModel)]="userData.college_id"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="college_id"
                              placeholder="Enter college"
                           #college_id />
                          </fieldset> -->
                          <!-- <fieldset class="form-group">
                            <label for="project_ids">Project Id</label>
                            <input
                              type="text"
                              [(ngModel)]="userData.project_ids"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="project_ids"
                              placeholder="Enter project id"
                           #project_ids />
                          </fieldset> -->
                          <!-- <fieldset class="form-group">
                            <label for="placementInfo">placement Info</label>
                            <input
                              type="text"
                              [(ngModel)]="userData.placementInfo"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="placementInfo"
                              placeholder="Enter placement Info"
                           #placementInfo />
                          </fieldset> -->
                          <!-- <fieldset class="form-group">
                            <label for="overview">overview</label>
                            <textarea id="hidden-label-form-6" rows="5" [(ngModel)]="courseData.overview" [ngModelOptions]="{standalone: true}" class="form-control " name="comment2"  placeholder="Enter Course Durations"#overview></textarea>
                          </fieldset> -->
                          <!-- <fieldset class="form-group">
                            <label for="last_qualificaiton"
                              >last Qualification</label >
                            <input
                              type="text"
                              [(ngModel)]="userData.last_qualificaiton"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="last_qualificaiton"
                              placeholder="Enter last qualificaiton"
                           #last_qualificaiton />
                          </fieldset> -->

                          <!-- <fieldset class="form-group">
                                 <ng-select [items]="courses"  bindLabel="courseName" bindValue="_id" [multiple]="true" [closeOnSelect]="false"
                                placeholder="Select course" [(ngModel)]="selectedValue"
                                 [ngModelOptions]="{ standalone: true }" (change)="getCourseId($event)"  >
                              
                              </ng-select>
                              </fieldset> -->
                          <!-- <fieldset class="form-group">
                                <ng-select
                                  [items]="batchList"
                                  bindLabel="name"
                                  bindValue="_id"
                                  [multiple]="true"
                                  [closeOnSelect]="false"
                                  placeholder="Select Batch"
                                  [(ngModel)]="selectedBatch"
                                  [ngModelOptions]="{ standalone: true }"
                                  (change)="getBatchId($event)"
                                >
                                </ng-select>
                              </fieldset> -->
                          <!-- Default switch -->
                          <div class="custom-control custom-switch">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id="customSwitches"
                              (click)="setPassword()"
                            />
                            <label
                              class="custom-control-label"
                              for="customSwitches"
                              >Set Password</label
                            >
                          </div>
                          <fieldset class="form-group" *ngIf="isPassword">
                            <label for="password">password</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="userData.password"
                              [ngModelOptions]="{ standalone: true }"
                              id="name"
                              placeholder="enter password"
                              #password
                            />
                          </fieldset>
                        </div>

                        <div
                          class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                        >
                          <button
                            type="submit"
                            class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                            (click)="userUpdate()"
                          >
                            Save Changes
                          </button>
                          <button
                            type="reset"
                            class="btn btn-secondary"
                            (click)="back()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                    <!-- Account form ends -->
                  </div>
                  <!-- Account content ends -->
                </ng-template>
              </li>
              <li [ngbNavItem]="2">
                <!-- <a ngbNavLink class="nav-link d-flex align-items-center">
                  <i class="ft-info mr-1"></i>
                  <span class="d-none d-sm-block">Information</span>
                </a> -->
                <ng-template ngbNavContent>
                  <!-- Information content starts -->
                  <div class="mt-2" id="information">
                    <!-- Information form starts -->
                    <form novalidate>
                      <div class="row">
                        <div class="col-12 col-md-6 mb-3 mb-md-0">
                          <h4 class="mb-3">
                            <i class="ft-link mr-2"></i>Social Links
                          </h4>
                          <!-- <div class="form-group">
                              <label for="users-edit-twitter">Twitter</label>
                              <input type="text" id="users-edit-twitter" class="form-control"
                                value="https://www.twitter.com/">
                            </div> -->
                          <div class="form-group">
                            <label for="users-edit-facebook">Facebook</label>
                            <input
                              type="text"
                              id="users-edit-facebook"
                              class="form-control"
                              value="https://www.facebook.com/"
                            />
                          </div>
                          <fieldset class="form-group">
                            <label for="Phone">PhoneNumber</label>
                            <input
                              type="text"
                              id="PhoneNumber"
                              [(ngModel)]="userData.phone"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              placeholder=" enter
                              Phone Number"
                            />
                            <!-- <small class="text-muted">Find helper text here for given textbox.</small> -->
                          </fieldset>
                          <!-- <div class="form-group">
                              <label for="users-edit-google">Google+</label>
                              <input type="text" id="users-edit-google" class="form-control">
                            </div>
                            <div class="form-group">
                              <label for="users-edit-linkedin">LinkedIn</label>
                              <input type="text" id="users-edit-linkedin" class="form-control">
                            </div>
                            <div class="form-group">
                              <label for="users-edit-instagram">Instagram</label>
                              <input type="text" id="users-edit-instagram" class="form-control"
                                value="https://www.instagram.com/">
                            </div> -->
                        </div>

                        <div class="col-12 col-md-6 mb-2 mb-md-0">
                          <h4 class="mb-3">
                            <i class="ft-user mr-2"></i>Personal Info
                          </h4>

                          <!-- <fieldset class="form-group">
                            <label for="address">address</label>
                            <input
                              type="text"
                              [(ngModel)]="userData.address"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="address"
                              placeholder="enter address"
                            />
                          </fieldset> -->
                          <fieldset class="form-group">
                            <label for="dob">DOB</label>
                            <input
                              type="date"
                              [(ngModel)]="userData.dob"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="dob"
                              placeholder="enter
                              DOB"
                            />
                          </fieldset>

                          <!-- <div class="form-group">
                              <div class="controls position-relative">
                                <label for="users-edit-bday">Birth date</label>
                                <input type="text" id="users-edit-bday" class="form-control birthdate-picker" required
                                  placeholder="Birth date">
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="controls">
                                <label for="users-edit-country">Country</label>
                                <select id="users-edit-country" class="form-control" required>
                                  <option value="">Select Country</option>
                                  <option value="USA">USA</option>
                                  <option value="UK">UK</option>
                                  <option value="India">India</option>
                                </select>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="users-edit-languages">Languages</label>
                              <ng-select [multiple]="true" [(ngModel)]="selectedLanguages" [ngModelOptions]="{standalone: true}">
                                <ng-option *ngFor="let language of languages" [value]="language.value">{{language.name}}
                                </ng-option>
                              </ng-select>
                            </div>
                            <div class="form-group">
                              <div class="controls">
                                <label for="users-edit-phone">Phone</label>
                                <input type="text" id="users-edit-phone" class="form-control" placeholder="Phone Number"
                                  required value="(+656) 254 2568">
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="controls">
                                <label for="users-edit-address">Address</label>
                                <input type="text" id="users-edit-address" class="form-control" placeholder="Address"
                                  required>
                              </div>
                            </div> -->
                        </div>
                        <!--   
                          <div class="col-12">
                            <div class="form-group">
                              <label for="users-edit-website">Website</label>
                              <input type="text" id="users-edit-website" class="form-control"
                                placeholder="Website Address">
                            </div>
                            <div class="form-group">
                              <label for="users-edit-music">Favourite Music</label>
                              <ng-select [multiple]="true" [(ngModel)]="selectedMusic" [ngModelOptions]="{standalone: true}">
                                <ng-option *ngFor="let m of music" [value]="m.value">{{m.name}}
                                </ng-option>
                              </ng-select>
                            </div>
                            <div class="form-group">
                              <label for="users-edit-movies">Favourite Movies</label>
                              <ng-select [multiple]="true" [(ngModel)]="selectedMovies" [ngModelOptions]="{standalone: true}">
                                <ng-option *ngFor="let movie of movies" [value]="movie.value">{{movie.name}}
                                </ng-option>
                              </ng-select>
                            </div>
                          </div> -->
                        <div
                          class="col-12 d-flex justify-content-end flex-sm-row flex-column mt-3 mt-sm-0"
                        >
                          <button
                            type="submit"
                            class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                            (click)="userUpdate()"
                          >
                            Save Changes
                          </button>
                          <button
                            type="reset"
                            class="btn btn-secondary"
                            (click)="back()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                    <!-- Information form ends -->
                  </div>
                  <!-- Information content ends -->
                </ng-template>
              </li>
            </ul>
            <div class="tab-content">
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section *ngIf="currentUrl == 'student-edit/:id'">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- Nav-tabs -->
            <ul
              ngbNav
              #nav="ngbNav"
              [activeId]="1"
              class="nav-tabs justify-content-left"
            >
              <li [ngbNavItem]="1">
                <a ngbNavLink class="nav-link d-flex align-items-center">
                  <i class="ft-user mr-1"></i>
                  <span class="d-none d-sm-block">Account</span>
                </a>
                <ng-template ngbNavContent>
                  <!-- Account content starts -->
                  <div class="mt-2" id="account">
                    <!-- Media object starts -->
                    <div class="media">
                      <!-- <img class="avatar" *ngIf="userData.image;else no_profile_image" [src]="imageUrl+userData.image"
                      alt="avatar" height="35" width="35" />
                      <ng-template #no_profile_image><img class="avatar" [src]="'assets/img/no_logo_found.jpeg'"
                        alt="avatar" height="35" width="35" /></ng-template> -->
                      <!-- <img *ngIf="!userData?.image" class="avatar" [src]="'assets/img/no_logo_found.jpeg'"
                        alt="avatar" height="64" width="64"> -->
                      <img
                        *ngIf="imgUrl"
                        [src]="imgUrl"
                        alt="user edit avatar"
                        class="users-avatar-shadow rounded mr-3 object-fit-cover"
                        height="64"
                        width="64"
                      />

                      <img
                        *ngIf="studentsData?.image && !imgUrl"
                        [src]="imageUrl + studentsData?.image"
                        alt="user edit avatar"
                        class="users-avatar-shadow rounded mr-3 object-fit-cover"
                        height="64"
                        width="64"
                      />
                      <div
                        *ngIf="!imgUrl && !studentsData?.image"
                        [class.initial-alpha]="!userData?.image"
                        class="users-avatar-shadow mr-1 ml-0 bg-primary"
                      >
                        <div class="avatar-content">
                          {{ studentsData?.name | titlecase | shortName }}
                        </div>
                      </div>
                      <!-- <div *ngIf="studentsData?.image">
                          <img class="users-avatar-shadow rounded mr-1" [src]="imgUrl"
                            height="64" width="64" alt="datatable-avatar">
                          <img class="users-avatar-shadow rounded mr-1" [src]="imageUrl + studentsData?.image"
                            height="64" width="64" alt="datatable-avatar">
                        </div>
                        
                          <div *ngIf="!studentsData?.image" [class.initial-alpha]="!studentsData?.image" class="users-avatar-shadow rounded mr-1 ml-0" >
                            <div class="avatar-content">{{ studentsData?.name | shortName }}</div>
                          </div> -->

                      <div class="media-body">
                        <h4>{{ studentsData?.name | titlecase }}</h4>
                        <div
                          class="d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2"
                        >
                          <label
                            class="btn btn-sm btn-primary mb-1 mb-sm-0 text-transform-unset"
                            >Change
                            <input
                              type="file"
                              #fileInput
                              class="form-control"
                              (change)="onSelectFile($event)"
                              hidden
                            />
                          </label>
                          <!-- <button
                            class="btn btn-sm bg-light-secondary ml-sm-2"
                            (click)="resetImage()"
                          >
                            Reset
                          </button> -->
                        </div>
                      </div>
                    </div>
                    <!-- Media object ends -->

                    <!-- Account form starts -->
                    <form novalidate>
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <!-- <fieldset class="form-group">
                            <label for="name">Role</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="studentsData.roles"
                              [ngModelOptions]="{ standalone: true }"
                              id="name"
                              placeholder="Enter role"
                              readonly
                            />
                          </fieldset> -->
                          <fieldset class="form-group">
                            <label for="name">Name</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="studentsData.name"
                              [ngModelOptions]="{ standalone: true }"
                              id="name"
                              placeholder="Enter name"
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label class="form-control-label" for="badges">
                              Student Badge</label
                            >
                            <ng-select
                              [items]="badgeList"
                              bindLabel="name"
                              bindValue="_id"
                              [multiple]="true"
                              [closeOnSelect]="false"
                              placeholder="Select Badge"
                              [(ngModel)]="selectBadge"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getBadgeId($event)"
                            >
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="Email">Email</label>
                            <input
                              type="email"
                              class="form-control"
                              [(ngModel)]="studentsData.email"
                              [ngModelOptions]="{ standalone: true }"
                              id="Email"
                              placeholder="Enter email"
                              #email
                            />
                          </fieldset>
                          <fieldset>
                            <label for="">Gender</label>
                            <select
                              class="form-control"
                              aria-placeholder="Sex"
                              (change)="change($event)"
                              [(ngModel)]="studentsData.sex"
                              [ngModelOptions]="{ standalone: true }"
                            >
                              <option value="">Select Gender</option>
                              <option value="male">male</option>
                              <option value="female">female</option>
                            </select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="college">Phone</label>
                            <input
                              type="text"
                              placeholder="e.g. 1234-567-890"
                              mask="0000-000-000"
                              minlength="10"
                              [(ngModel)]="studentsData.phone"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="phone"
                              placeholder="Enter phone"
                              #phone
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="bio">Bio</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="studentsData.bio"
                              [ngModelOptions]="{ standalone: true }"
                              id="bio"
                              placeholder="Enter bio"
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label class="form-control-label" for="huntingBy"
                              >Hunting by</label
                            >
                            <ng-select
                              [items]="usersList"
                              bindLabel="name"
                              bindValue="_id"
                              placeholder="Hunting By"
                              [(ngModel)]="selectedHuntingBy"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getHuntId($event)"
                            >
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label class="form-control-label" for="farmingBy"
                              >Farming by</label
                            >
                            <ng-select
                              [items]="usersList"
                              bindLabel="name"
                              bindValue="_id"
                              placeholder="Farming By"
                              [(ngModel)]="selectedFarmingBy"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getFarmId($event)"
                            >
                            </ng-select>
                          </fieldset>
                          <!-- <fieldset class="form-group">
                            <label class="form-control-label" for="goal"
                              >Goal</label
                            >
                            <ng-select
                              [items]="goalList"
                              bindLabel="displayname"
                              bindValue="_id"
                              [closeOnSelect]="false"
                              placeholder="Select Goal"
                              [(ngModel)]="selectGoal"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getGoalId($event)"
                            >
                            </ng-select>
                          </fieldset> -->
                          <fieldset class="form-group">
                            <label class="form-control-label" for="goal"
                              >Team</label
                            >
                            <ng-select
                              [items]="teamList"
                              bindLabel="displayname"
                              bindValue="_id"
                              [closeOnSelect]="true"
                              placeholder="Select Team"
                              [(ngModel)]="selectedTeam"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getTeamId($event)"
                            >
                            </ng-select>
                          </fieldset>
                          <!-- <fieldset class="form-group">
                            <label class="form-control-label" for="huntingBy">Hunting by</label>
                            <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Hunting By"
                              [(ngModel)]="selectedHuntingBy" [ngModelOptions]="{ standalone: true }"
                              (change)="getHuntId($event)">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label class="form-control-label" for="farmingBy">Farming by</label>
                            <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Farming By"
                              [(ngModel)]="selectedFarmingBy" [ngModelOptions]="{ standalone: true }"
                              (change)="getFarmId($event)">
                            </ng-select>
                            </fieldset> -->

                          <fieldset class="form-group">
                            <label for="dob">Date Of Birth</label>
                            <input
                              type="date"
                              [(ngModel)]="studentsData.dob"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="dob"
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="">College</label>
                            <ng-select
                              [items]="collegeList"
                              bindLabel="name"
                              bindValue="_id"
                              placeholder="Select College"
                              [(ngModel)]="selectedCollege"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getCollegeId($event)"
                              #college="ngModel"
                            >
                            </ng-select>
                          </fieldset>
                          <!-- <fieldset class="form-group">
                            <label for="project_ids">Project Id</label>
                            <input
                              type="text"
                              [(ngModel)]="studentsData.project_ids"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="project_ids"
                              placeholder="Enter project id"
                           #project_ids />
                          </fieldset> -->
                          <fieldset class="form-group">
                            <label for="placementinfo">placement Info</label>
                            <input
                              type="text"
                              [(ngModel)]="studentsData.placementinfo"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="placementinfo"
                              placeholder="Enter placement Info"
                              #placementinfo
                            />
                          </fieldset>
                          <!------------------------ Student Form Fields ------------------------------------>
                          <!-- <fieldset class="form-group">
                          <label for="bio">Bio</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.bio"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="bio" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="badges">Badges</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.badges"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="badges" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="goal">Goal</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.goal"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="goal" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="mode">Mode</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.mode"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="mode" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="hunting_by">Hunting By</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.hunting_by"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="hunting_by" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="farming_by">Farming By</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.farming_by"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="farming_by" readonly />
                        </fieldset> -->
                          <!-- <fieldset class="form-group">
                          <label for="team">Team</label>
                          <input
                            type="text"
                            [(ngModel)]="userData.team"
                            [ngModelOptions]="{ standalone: true }"
                            class="form-control"
                            id="team" readonly />
                        </fieldset> -->
                          <!-- ---------------- End -------------------------------------------- -->
                        </div>
                        <div class="col-12 col-md-6">
                          <!-- ----------------User Form Fields -------------------------------------------- -->
                          <!-- <fieldset class="form-group">
                            <label for="address">address</label>
                            <input
                              (keydown.enter)="$event.preventDefault()"
                              type="text"
                              [(ngModel)]="studentsData?.location.address"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="address"
                              placeholder="Enter address"
                              #search
                            />
                          </fieldset> -->
                          <fieldset class="form-group">
                            <label for="next_payment_date"
                              >Next Payment Date</label
                            >
                            <input
                              type="date"
                              class="form-control"
                              [(ngModel)]="studentsData.next_payment_date"
                              [ngModelOptions]="{ standalone: true }"
                              id="next_payment_date"
                              placeholder="Enter Next Payment Date"
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="last_qualification"
                              >last Qualification</label
                            >
                            <input
                              type="text"
                              [(ngModel)]="studentsData.last_qualification"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="last_qualification"
                              placeholder="Enter last qualificaiton"
                              #last_qualification
                            />
                          </fieldset>

                          <fieldset class="form-group">
                            <label for="bio">Bio</label>
                            <input
                              type="text"
                              [(ngModel)]="studentsData.bio"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="bio"
                              placeholder="Enter Bio"
                              #bio
                            />
                          </fieldset>

                          <!-- <fieldset class="form-group">
                            <label class="form-control-label" for="mode"
                              >Learning Mode</label
                            >
                            <ng-select
                              [items]="learningList"
                              bindLabel="displayname"
                              bindValue="_id"
                              placeholder=" Select Mode"
                              [(ngModel)]="selectLearningMode"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getModeId($event)"
                            >
                            </ng-select>
                          </fieldset> -->
                          <fieldset class="form-group">
                            <label>Course</label>
                            <ng-select
                              [items]="courseList"
                              bindLabel="title"
                              bindValue="_id"
                              placeholder="Select Course"
                              [(ngModel)]="selectedCourse"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getCourseId($event)"
                            >
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="notes">Notes</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="5"
                              [(ngModel)]="studentsData.notes"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              name="comment2"
                              placeholder="Enter notes"
                              #notes
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="admin_notes">Admin Notes</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="5"
                              [(ngModel)]="studentsData.admin_notes"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              name="comment2"
                              placeholder="Enter admin notes"
                              #admin_notes
                            ></textarea>
                          </fieldset>
                          <!-- ---------------------- End ----------------------------------------------------------------- -->
                          <!-- ---------------------- Student Form Fields  ----------------------------------------------------------------- -->

                          <fieldset class="form-group">
                            <label for="overview">overview</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="5"
                              [(ngModel)]="studentsData.overview"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              name="comment2"
                              placeholder="Enter Course Durations"
                              #overview
                            ></textarea>
                          </fieldset>

                          <!-- Default switch -->
                          <!-- <div class="custom-control custom-switch ">
                            <input type="checkbox" class="custom-control-input" id="customSwitches" (click)="setPassword()">
                            <label class="custom-control-label" for="customSwitches">Set Password</label>
                          </div>
                          <fieldset class="form-group" *ngIf="isPassword">
                            <label for="password">password</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="userData.password"
                              [ngModelOptions]="{ standalone: true }"
                              id="name"
                              placeholder="enter password"
                           #password />
                          </fieldset> -->
                        </div>

                        <div
                          class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                        >
                          <button
                            type="submit"
                            class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                            (click)="studentUpdate()"
                          >
                            Save Changes
                          </button>
                          <button
                            type="reset"
                            class="btn btn-secondary"
                            (click)="backToStudent()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                    <!-- Account form ends -->
                  </div>
                  <!-- Account content ends -->
                </ng-template>
              </li>
              <li [ngbNavItem]="2">
                <!-- <a ngbNavLink class="nav-link d-flex align-items-center">
                  <i class="ft-info mr-1"></i>
                  <span class="d-none d-sm-block">Information</span>
                </a> -->
                <ng-template ngbNavContent>
                  <!-- Information content starts -->
                  <div class="mt-2" id="information">
                    <!-- Information form starts -->
                    <form novalidate>
                      <div class="row">
                        <div class="col-12 col-md-6 mb-3 mb-md-0">
                          <h4 class="mb-3">
                            <i class="ft-link mr-2"></i>Social Links
                          </h4>
                          <!-- <div class="form-group">
                              <label for="users-edit-twitter">Twitter</label>
                              <input type="text" id="users-edit-twitter" class="form-control"
                                value="https://www.twitter.com/">
                            </div> -->
                          <div class="form-group">
                            <label for="users-edit-facebook">Facebook</label>
                            <input
                              type="text"
                              id="users-edit-facebook"
                              class="form-control"
                              value="https://www.facebook.com/"
                            />
                          </div>
                          <fieldset class="form-group">
                            <label for="Phone">PhoneNumber</label>
                            <input
                              type="text"
                              id="PhoneNumber"
                              [(ngModel)]="userData.phone"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              placeholder=" enter
                              Phone Number"
                            />
                            <!-- <small class="text-muted">Find helper text here for given textbox.</small> -->
                          </fieldset>
                          <!-- <div class="form-group">
                              <label for="users-edit-google">Google+</label>
                              <input type="text" id="users-edit-google" class="form-control">
                            </div>
                            <div class="form-group">
                              <label for="users-edit-linkedin">LinkedIn</label>
                              <input type="text" id="users-edit-linkedin" class="form-control">
                            </div>
                            <div class="form-group">
                              <label for="users-edit-instagram">Instagram</label>
                              <input type="text" id="users-edit-instagram" class="form-control"
                                value="https://www.instagram.com/">
                            </div> -->
                        </div>

                        <div class="col-12 col-md-6 mb-2 mb-md-0">
                          <h4 class="mb-3">
                            <i class="ft-user mr-2"></i>Personal Info
                          </h4>

                          <!-- <fieldset class="form-group">
                            <label for="address">address</label>
                            <input
                              type="text"
                              [(ngModel)]="userData.address"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="address"
                              placeholder="enter address"
                            />
                          </fieldset> -->
                          <fieldset class="form-group">
                            <label for="dob">DOB</label>
                            <input
                              type="date"
                              [(ngModel)]="userData.dob"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="dob"
                              placeholder="enter
                              DOB"
                              readonly
                            />
                          </fieldset>

                          <!-- <fieldset class="form-group">
                              <label class="form-control-label" for="goal">Goal</label>
                              <ng-select [items]="goalList" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false"
                                placeholder="Select Goal" [(ngModel)]="goal" [ngModelOptions]="{ standalone: true }">
                              </ng-select>
                            </fieldset> -->

                          <!-- <div class="form-group">
                              <div class="controls position-relative">
                                <label for="users-edit-bday">Birth date</label>
                                <input type="text" id="users-edit-bday" class="form-control birthdate-picker" required
                                  placeholder="Birth date">
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="controls">
                                <label for="users-edit-country">Country</label>
                                <select id="users-edit-country" class="form-control" required>
                                  <option value="">Select Country</option>
                                  <option value="USA">USA</option>
                                  <option value="UK">UK</option>
                                  <option value="India">India</option>
                                </select>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="users-edit-languages">Languages</label>
                              <ng-select [multiple]="true" [(ngModel)]="selectedLanguages" [ngModelOptions]="{standalone: true}">
                                <ng-option *ngFor="let language of languages" [value]="language.value">{{language.name}}
                                </ng-option>
                              </ng-select>
                            </div>
                            <div class="form-group">
                              <div class="controls">
                                <label for="users-edit-phone">Phone</label>
                                <input type="text" id="users-edit-phone" class="form-control" placeholder="Phone Number"
                                  required value="(+656) 254 2568">
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="controls">
                                <label for="users-edit-address">Address</label>
                                <input type="text" id="users-edit-address" class="form-control" placeholder="Address"
                                  required>
                              </div>
                            </div> -->
                        </div>
                        <!--   
                          <div class="col-12">
                            <div class="form-group">
                              <label for="users-edit-website">Website</label>
                              <input type="text" id="users-edit-website" class="form-control"
                                placeholder="Website Address">
                            </div>
                            <div class="form-group">
                              <label for="users-edit-music">Favourite Music</label>
                              <ng-select [multiple]="true" [(ngModel)]="selectedMusic" [ngModelOptions]="{standalone: true}">
                                <ng-option *ngFor="let m of music" [value]="m.value">{{m.name}}
                                </ng-option>
                              </ng-select>
                            </div>
                            <div class="form-group">
                              <label for="users-edit-movies">Favourite Movies</label>
                              <ng-select [multiple]="true" [(ngModel)]="selectedMovies" [ngModelOptions]="{standalone: true}">
                                <ng-option *ngFor="let movie of movies" [value]="movie.value">{{movie.name}}
                                </ng-option>
                              </ng-select>
                            </div>
                          </div> -->
                        <div
                          class="col-12 d-flex justify-content-end flex-sm-row flex-column mt-3 mt-sm-0"
                        >
                          <button
                            type="submit"
                            class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                            (click)="userUpdate()"
                          >
                            Save Changes
                          </button>
                          <button
                            type="reset"
                            class="btn btn-secondary"
                            (click)="back()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                    <!-- Information form ends -->
                  </div>
                  <!-- Information content ends -->
                </ng-template>
              </li>
            </ul>
            <div class="tab-content">
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
